<script>
  import {styleVars} from '/helper'
  import Card from '/components/Atoms/Card.svelte'

  export let title, subtitle, date, image, large, caps, link = null, ongoing = false, faded = false

  let imageUrl = `url("${image}")`
</script>

<Card {link} flow verticalPadding={ongoing ? [34,22] : false}>
  <div class="container" class:faded class:ongoing class:large={large} class:image style={styleVars({imageUrl})}>
    <h4 class="date">
      {date}
    </h4>
    <div class="content">
      {#if title}
        <h3 class="title">
          {title}
        </h3>
      {/if}
      {#if subtitle}
        <h4 class="subtitle">
          {subtitle}
        </h4>
      {/if}
    </div>
    <span class="date">&nbsp;</span>
  </div>
</Card>

<style lang="scss">

  .container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    text-align: center;
    &.image {
      background-image: var(--imageUrl);
    }
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    min-height: 200px;

    &.ongoing {
      margin-bottom: -34px;
      @include media-small {
        margin-bottom: -22px;
      }
    }
    &.faded {
      opacity: 0.4;
    }
  }
  .date {
    @include typo-grotesk-title-captions-20;
    color: $color-red;
    .ongoing & {
      text-align: left;
    }

    .faded & {
      color: $color-text;
    }
  }

  .title, .subtitle {
    @include typo-serif-title-32;
  }

  .large .title,
  .large .subtitle {
    @include typo-serif-title-44;
  }

  .subtitle {
    font-style: italic;
  }

</style>